import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowRight } from "react-icons/fa6";
import PocketBase from 'pocketbase';
import { MdOutlineNewspaper } from "react-icons/md";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

const NewsCard = () => {
  const [, setCurrentSlide] = useState(0);
  const [, setNewsData] = useState([]);
  const navigate = useNavigate();
  const [filteredNewsData, setFilteredNewsData] = useState([]);

  useEffect(() => {
    const fetchNews = async () => {
      const response = await pb.collection('News').getFullList();
      setNewsData(response);
      const activeNews = response.filter(news => news.active);
      setFilteredNewsData(activeNews);
    }
    fetchNews();
  },[]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  const handleReadMore = (id) => {
    navigate(`/news/${id}`);
  };

  return (
    <div className="news-carousel">
    <h2 className="text-3xl font-bold text-blue-800 m-1 flex items-center gap-2">
      Latest News <MdOutlineNewspaper className="w-6 h-6" />
    </h2>
      <Slider {...settings}>
        {filteredNewsData.map((news) => (
          <div key={news.id} className="carousel-slide">
            <img src={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${news.collectionId}/${news.id}/${news.image}`} alt={news.title} className="slide-image" />
            <div className="slide-content">
              <h3 className="slide-title text-white">{news.title}</h3>
              <p className="slide-excerpt">{news.excerpt}</p>
              <button
                className="read-more-btn"
                onClick={() => handleReadMore(news.id)}>
                {" "}
                Read More{"  "}
                <span className="ml-1">
                   <FaArrowRight />{" "}
                </span>
              </button>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default NewsCard;
